import React, { useState, useEffect } from 'react';
import { Form, Button, message } from 'antd';
import { useTranslation } from 'react-i18next';
import { useLifestyleCategoriesI18n } from '../utils/lifestyleCategoriesI18n';
import LifestyleCategoryFormI18n from './intake/LifestyleCategoryFormI18n';

const PatientIntakeMovement = ({ sessionId, initialData, onSave, onNext, onPrevious }) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation();

  // Get movement category from i18n-enabled lifestyle categories
  const lifestyleCategories = useLifestyleCategoriesI18n();
  const movementCategory = lifestyleCategories.find(cat => cat.key === 'movement');

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      form.setFieldsValue(initialData);
    }
  }, [initialData, form]);

  const handleFinish = async (values) => {
    setLoading(true);
    // Include category indicator to mark this section as completed
    const dataWithCategory = {
      ...values,
      _completedCategory: 'movement'
    };
    const success = await onSave(dataWithCategory);
    if (success) {
      // Scroll to top before moving to next step
      window.scrollTo({ top: 0, behavior: 'smooth' });
      onNext();
    }
    setLoading(false);
  };

  const handlePrevious = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    onPrevious();
  };

  if (!movementCategory) {
    return <div>Error: Movement category not found</div>;
  }

  return (
    <div className="intake-form-section">
      <h3>{t('lifestyle.headers.physicalActivityMovement')}</h3>
      <p>{t('lifestyle.headers.movementDescription')}</p>

      <Form
        form={form}
        layout="vertical"
        onFinish={handleFinish}
        autoComplete="off"
        size="large"
      >
        <LifestyleCategoryFormI18n
          category={movementCategory}
          formName="movement"
        />

        <div className="intake-form-buttons">
          <Button
            onClick={handlePrevious}
            size="large"
          >
            {t('common.previous')}
          </Button>

          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            size="large"
          >
            {t('common.save')} & {t('common.next')}
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default PatientIntakeMovement;
